import { EventName } from '@lit/react';
import { BlocksAccordionPanel } from 'blocks-nextjs/blocks-web-components/components/accordion-panel/accordion-panel';
import { BlockAccordionCloseEvent, BlockAccordionOpenEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatAccordionPanel = createComponent({
  react: React,
  tagName: 'cat-accordion-panel',
  elementClass: BlocksAccordionPanel,
  events: {
    onBlAccordionOpen: 'bl-accordion-open' as EventName<BlockAccordionOpenEvent>,
    onBlAccordionClose: 'bl-accordion-close' as EventName<BlockAccordionCloseEvent>
  }
});
